export default __webpack_public_path__ + "static/media/create_alert.3d958a9f.png";